export default "__VITE_ASSET__Ce53wrxW__"